module.exports = __webpack_public_path__ + "static/media/green-check-border.3a60c3be.svg";